import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { environment } from '/src/shared/env'

const firebaseConfig = {
  apiKey: environment('VUE_APP_FIREBASE_API_KEY'),
  authDomain: environment('VUE_APP_FIREBASE_AUTH_DOMAIN')
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Auth
const auth = getAuth(app)

export { app, auth }